var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, Injector, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ClaimModifyServiceProxy, ModifyClaimDto } from '@shared/service-proxies/service-proxies';
import { MyCommandCenterService } from '@app/main/my-command-centre/my-command-center.service';
var MyWearablesModalComponent = /** @class */ (function (_super) {
    __extends(MyWearablesModalComponent, _super);
    function MyWearablesModalComponent(modalRef, injector, _claimModify, _commandCenterService) {
        var _this = _super.call(this, injector) || this;
        _this.modalRef = modalRef;
        _this._claimModify = _claimModify;
        _this._commandCenterService = _commandCenterService;
        _this.saving = false;
        _this.checkTermsCondition = false;
        _this.onClose = new EventEmitter();
        return _this;
    }
    MyWearablesModalComponent.prototype.ngOnInit = function () {
        this.isWearables = this.type === 'Wearable';
    };
    MyWearablesModalComponent.prototype.updateIdNumberClaim = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mdto;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mdto = new ModifyClaimDto();
                        mdto.accessToken = this._authService.user.access_token;
                        mdto.newClaimType = 'id_number';
                        mdto.newClaimValue = this.idNumber.toString();
                        mdto.userId = this._authGuard.user.profile.sub;
                        this._authGuard.user.profile.id_number = this.idNumber.toString();
                        return [4 /*yield*/, this._claimModify.modifyClaim(mdto).toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.updateClaimsIdsvr()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyWearablesModalComponent.prototype.save = function () {
        var _this = this;
        this.saving = true;
        if (this._authGuard.user.profile.id_number !== this.idNumber.toString()) {
            if (this._authGuard.user.profile.id_number === '0000000000000') {
                this.updateIdNumberClaim().then(function () {
                    _this.resetProps();
                    _this.updateClaimsIdsvr().then(function () {
                        _this.close(true);
                    });
                });
            }
            else {
                abp.message.warn('Your ID number does not match the one we have on record', 'Wearables activation failed', false);
                this._commandCenterService.changeTemplatePopup('OK', undefined);
                this.resetProps();
                this.close(false);
            }
        }
        else {
            this.resetProps();
            this.close(true);
        }
    };
    MyWearablesModalComponent.prototype.resetProps = function () {
        this.idNumber = null;
        this.checkTermsCondition = false;
        this.saving = false;
    };
    MyWearablesModalComponent.prototype.close = function (success) {
        this.modalRef.hide();
        this.onClose.next(success);
    };
    return MyWearablesModalComponent;
}(AppComponentBase));
export { MyWearablesModalComponent };
